import { render } from "./CustomerCaseListDetail.vue?vue&type=template&id=11c9f927&scoped=true"
import script from "./CustomerCaseListDetail.vue?vue&type=script&lang=js"
export * from "./CustomerCaseListDetail.vue?vue&type=script&lang=js"

import "./CustomerCaseListDetail.vue?vue&type=style&index=0&id=11c9f927&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c9f927"]])

export default __exports__